import Error from "./../../helpers/Error";
import { GET_TOKEN_ENDPOINT } from "../../constants/ApiConstants";
import axios from "axios";

export default function getTokenCall(username: string, password: string) {
    return axios
        .post(GET_TOKEN_ENDPOINT, {
            username,
            password
        })
        .then(response => response.data)
        .catch(error => {
            throw new Error(error.response.data.message, error.response.data.code);
        });
}
